import { Action } from '../types';

export const dismissGoogleOneTap = (): Action => ({
  type: 'GOOGLE_ONE_TAP_DISMISS',
});
